import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BaseComponent } from 'src/app/core/base/base.component';
import { AdminLocationModel } from 'src/app/model/admin/location';
import { BaseModalModel } from 'src/app/model/core/base-modal';
import { LOCATION_CONSTANTS } from './admin-location.constants';
import { AdminLocationService } from './admin-location.service';

@Component({
  selector: 'ms-admin-location',
  templateUrl: './admin-location.component.html',
})
export class AdminLocationComponent extends BaseComponent {
  readonly screen = LOCATION_CONSTANTS;
  protected setScreen = true;
  locations: AdminLocationModel[] = [];
  selectedLocation: AdminLocationModel = {};
  modal: BaseModalModel = { value: {} };
  dtNameFilter?: string;
  options: MenuItem[] = [];

  constructor(protected service: AdminLocationService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service.getLocationModal().subscribe(this.setModal),
      this.service.getLocationStore().subscribe(this.setLocationStore)
    );
    this.setDefaultContextMenu();
  };

  openModal = () => this.service.openModal();

  save = () => {
    this.service.setLoadingState();
    this.subscriptions.push(this.service.save(this.modal.value).subscribe());
  };

  setContextMenuItems = () => {
    const idx = this.options.findIndex((op) => op.id === 'enableDisable');
    this.options[idx] = {
      ...this.options[idx],
      label:
        this.screen.actions[
          this.selectedLocation.status ? 'disable' : 'enable'
        ],
      styleClass: `text-${this.selectedLocation.status ? 'danger' : 'success'}`,
      icon: `far ${
        this.selectedLocation.status ? 'fa-trash-alt' : 'fa-check-circle'
      }`,
    };
  };

  private setDefaultContextMenu = () => {
    this.options.push({
      id: 'edit',
      label: this.screen.actions.edit,
      styleClass: 'text-warning',
      icon: 'fas fa-pencil-alt',
      command: () => this.service.openModal(this.selectedLocation),
    });
    this.options.push({
      id: 'enableDisable',
      label: this.screen.actions.disable,
      styleClass: 'text-danger',
      icon: 'far fa-trash-alt',
      command: (_) =>
        this.subscriptions.push(
          this.service.patchStatus(this.selectedLocation.id).subscribe()
        ),
    });
  };

  private setLocationStore = (store: AdminLocationModel[]) => {
    if (!store || store.length === 0) {
      this.subscriptions.push(
        this.service.readLocations().subscribe(this.setLocations)
      );
    } else {
      this.setLocations(store);
    }
  };

  private setLocations = (locations: AdminLocationModel[]) =>
    (this.locations = locations);

  private setModal = (modal: BaseModalModel<AdminLocationModel>) =>
    (this.modal = modal);
}
